import { OptionsContext } from 'contexts/OptionsContext/OptionsContext';
import useNonNullContext from '../../Hooks/useNonNullContext';
import { useCreatorbaseCurrencies } from 'contexts/CreatorbaseCurrencyContext';
import { mapCurrencyToOption } from '@round/creatorbase-helpers/api-hooks';

export { mapCurrencyToOption };
export type { CurrencyOption } from '@round/creatorbase-helpers/api-hooks';

export function useCurrencies() {
    const { currencies } = useNonNullContext(OptionsContext);
    const { currencies: creatorbaseCurrencies } = useCreatorbaseCurrencies();

    const options = currencies.map(mapCurrencyToOption);
    const creatorbaseOptions = (creatorbaseCurrencies || []).map(mapCurrencyToOption);

    // The function still returns the original currencies,
    // but the options are creatorbase currencies are also included when we search for an option by id.
    return {
        currencies,
        options,
        getCurrencyById: (id: number | null | undefined) => {
            // Search in both currencies and creatorbaseCurrencies
            return currencies.find((c) => c.id === id) || (creatorbaseCurrencies || []).find((c) => c.id === id);
        },
        getCurrencyOptionsById: (id: number | null | undefined) =>
            options.find((o) => o.value === id) || creatorbaseOptions.find((o) => o.value === id),
    };
}
